(function () {
  'use strict';

  function hasAccessibleName(el) {
    if (el.getAttribute('aria-label')) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    if (el.getAttribute('title')) return true;
    var img = el.querySelector('img[alt]:not([alt=""])');
    if (img) return true;
    var text = '';
    try {
      text = (el.innerText || '').trim();
    } catch (e) {
      text = (el.textContent || '').trim();
    }
    if (text) return true;
    return false;
  }

  function fixEmptyRoleButtons() {
    document.querySelectorAll('[role="button"]').forEach(function (el) {
      if (!hasAccessibleName(el)) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function fixEmptyLinks() {
    document.querySelectorAll('a').forEach(function (a) {
      if (a.getAttribute('aria-hidden') === 'true') return;
      if (a.getAttribute('aria-label')) return;
      if (hasAccessibleName(a)) return;
      var href = a.getAttribute('href');
      if (!href || href === '#') {
        a.setAttribute('aria-hidden', 'true');
        a.setAttribute('tabindex', '-1');
      } else {
        try {
          var url = new URL(a.href, window.location.origin);
          var label = url.hostname.replace('www.', '');
          if (url.pathname && url.pathname !== '/') {
            label += ' ' + url.pathname.replace(/\//g, ' ').trim();
          }
          a.setAttribute('aria-label', label);
        } catch (e) {
          a.setAttribute('aria-hidden', 'true');
          a.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  function fixBoldSpans() {
    document.querySelectorAll('span[style]').forEach(function (span) {
      var style = span.getAttribute('style') || '';
      if (!/font-weight\s*:\s*(bold|[6-9]\d{2}|1000)/i.test(style)) return;
      if (span.querySelector('strong')) return;
      var strong = document.createElement('strong');
      while (span.firstChild) {
        strong.appendChild(span.firstChild);
      }
      span.appendChild(strong);
      span.style.fontWeight = '';
    });
  }

  function runFixes() {
    fixEmptyRoleButtons();
    fixEmptyLinks();
    fixBoldSpans();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes);
  } else {
    runFixes();
  }

  var debounceTimer;
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (!shouldRun) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runFixes, 300);
  });

  var observeTarget = document.body || document.documentElement;
  if (observeTarget) {
    observer.observe(observeTarget, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
